import React from "react";
import Typography from "@material-ui/core/Typography";
const SalesReports = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Sales Reports
      </Typography>
      <Typography paragraph variant="h5">
        Explore dashboard and various reports of Sales module
      </Typography>
      <Typography paragraph variant="body1">
        Sales Reports is one of the features under the Sales module to display
        various reports regarding the Sales business process. It is used to
        analyze information, determine conclusions, and offer recommendations to
        solve problems.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the tabs indicating
        the various report types. The various reports under the Sales module are
        listed below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Sales Dashboard</b>
        <br />
        This is the main dashboard of the Sales module. There is a lot of
        high-level information shown as a widget to give you the best insight
        regarding what happens in the Sales business process. This best analytic
        information will help you a lot to make business decisions. Below are
        the available widgets inside this dashboard:
        <ul>
          <li>Sales Widget</li>
          <li>Customers Widget</li>
          <li>Deals Won Widget</li>
          <li>Sales Achieved Widget</li>
          <li>Sales Order Overview Widget</li>
          <li>Sales Target vs Actual Widget</li>
          <li>Top 5 Customers Widget</li>
          <li>Top 5 Sales Items Widget</li>
          <li>Top 5 Salesman Widget</li>
          <li>Quotation Won vs Lost Widget</li>
          <li>Orders By Customer Type Widget</li>
          <li>Sales By Countries Widget</li>
        </ul>
      </Typography>
      <Typography paragraph variant="body1">
        <b>Sales Overview</b>
        <br />
        This report tells you about every sales by item sold and its total sales
        amount with a profitability analysis of each item.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Customer Analytics</b>
        <br />
        This report tells you about every sales by customer and its total sales
        amount with an average spent analysis of each customer to buy the
        company's product.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Outlet Sales</b>
        <br />
        This report tells you about every sales by outlet and its total sales
        amount with a net profit analysis of each outlet.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Sales Target</b>
        <br />
        This report tells you about every sales target by sales group and its
        total sales achieved every year accumulation.
      </Typography>
    </React.Fragment>
  );
};

export default SalesReports;
